import { currentAppSurface } from "../../platform/runtime.js";
import { recordProductEvent } from "./api.js";
import { readAcquisition } from "./attribution.js";

const SESSION_STORAGE_KEY = "axon-product-session-v1";

function createSessionId() {
  try {
    return globalThis.crypto?.randomUUID?.() || null;
  } catch {
    return null;
  }
}

export function productSessionId() {
  try {
    const current = globalThis.sessionStorage?.getItem(SESSION_STORAGE_KEY);
    if (current) return current;
    const created = createSessionId();
    if (created) globalThis.sessionStorage?.setItem(SESSION_STORAGE_KEY, created);
    return created;
  } catch {
    return createSessionId();
  }
}

function shouldAttribute(name, entityId) {
  return (name === "app.screen_viewed" && entityId === "today")
    || ["onboarding.started", "onboarding.activated", "onboarding.leads_opened", "lead_detail.opened"].includes(name);
}

export function productEventContext(name, entityId) {
  const sessionId = productSessionId();
  const surface = currentAppSurface();
  return {
    surface,
    ...(sessionId ? { sessionId } : {}),
    ...(surface === "web" && shouldAttribute(name, entityId) ? readAcquisition() || {} : {}),
  };
}

export async function recordUserAction(auth, input) {
  try {
    const token = await auth.getIdToken();
    if (!token) return null;
    return await recordProductEvent(token, {
      ...input,
      ...productEventContext(input.name, input.entityId),
    });
  } catch {
    return null;
  }
}

export function countBucket(value) {
  if (!Number.isFinite(value) || value <= 0) return "0";
  if (value === 1) return "1";
  if (value <= 5) return "2_5";
  if (value <= 10) return "6_10";
  return "11_plus";
}

export function durationBucket(milliseconds) {
  if (!Number.isFinite(milliseconds) || milliseconds < 10_000) return "under_10s";
  if (milliseconds < 30_000) return "10_30s";
  if (milliseconds < 120_000) return "30_120s";
  if (milliseconds < 300_000) return "2_5m";
  return "5m_plus";
}
